var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { getAddress } from '@ethersproject/address';
import { getTokenLockWallets } from './tokenLockWallets';
import { balanceStrategy } from '../the-graph-balance/balances';
import { indexersStrategy } from '../the-graph-indexing/indexers';
import { delegatorsStrategy } from '../the-graph-delegation/delegators';
import { verifyResults } from './graphUtils';
export function baseStrategy(_space, network, _provider, addresses, options, snapshot) {
    return __awaiter(this, void 0, void 0, function () {
        var tokenLockWallets, allAccounts, beneficiary, scores, combinedScores, _loop_1, _i, addresses_1, account;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    addresses = addresses.map(function (address) { return address.toLowerCase(); });
                    return [4 /*yield*/, getTokenLockWallets(_space, network, _provider, addresses, options, snapshot)];
                case 1:
                    tokenLockWallets = _a.sent();
                    allAccounts = __spreadArray([], addresses);
                    for (beneficiary in tokenLockWallets) {
                        tokenLockWallets[beneficiary].forEach(function (tw) {
                            allAccounts.push(tw);
                        });
                    }
                    scores = {};
                    if (!(options.strategyType == 'balance')) return [3 /*break*/, 3];
                    return [4 /*yield*/, balanceStrategy(_space, network, _provider, allAccounts, options, snapshot)];
                case 2:
                    scores = _a.sent();
                    return [3 /*break*/, 8];
                case 3:
                    if (!(options.strategyType == 'delegation')) return [3 /*break*/, 5];
                    return [4 /*yield*/, delegatorsStrategy(_space, network, _provider, allAccounts, options, snapshot)];
                case 4:
                    scores = _a.sent();
                    return [3 /*break*/, 8];
                case 5:
                    if (!(options.strategyType == 'indexing')) return [3 /*break*/, 7];
                    return [4 /*yield*/, indexersStrategy(_space, network, _provider, allAccounts, options, snapshot)];
                case 6:
                    scores = _a.sent();
                    return [3 /*break*/, 8];
                case 7:
                    console.error('ERROR: Strategy does not exist');
                    _a.label = 8;
                case 8:
                    if (options.expectedResults) {
                        verifyResults(JSON.stringify(scores), JSON.stringify(options.expectedResults.scores), 'Scores');
                    }
                    combinedScores = {};
                    _loop_1 = function (account) {
                        var accountScore = scores[account];
                        // It was found that this beneficiary has token lock wallets, lets add them
                        if (tokenLockWallets[account] != null) {
                            tokenLockWallets[account].forEach(function (tw) {
                                accountScore = accountScore + scores[tw];
                            });
                        }
                        combinedScores[account] = accountScore;
                    };
                    for (_i = 0, addresses_1 = addresses; _i < addresses_1.length; _i++) {
                        account = addresses_1[_i];
                        _loop_1(account);
                    }
                    if (options.expectedResults) {
                        verifyResults(JSON.stringify(combinedScores), JSON.stringify(options.expectedResults.combinedScores), 'Combined scores');
                    }
                    return [2 /*return*/, Object.fromEntries(Object.entries(combinedScores).map(function (score) { return [
                            getAddress(score[0]),
                            score[1]
                        ]; }))];
            }
        });
    });
}
